export default __webpack_public_path__ + "static/media/markList.c55f2f04.png";